import React from 'react';
import PropTypes from 'prop-types';
import createClass from 'create-react-class';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {Button, Input} from 'ui-library';
import i18n from 'i18n';

import {deleteBrand} from 'redux/modules/brands';
import {hideModal, resetRequest, showAlert, changePage} from 'redux/modules/app';

import {getBrand, getRequest} from 'modules/shared/selectors';
import Dialog from 'modules/legacy/js/components/dialog';
import {BrandAvatar} from 'modules/shared/components';


function mapStateToProps(state, {brandId}) {
  return {
    brand: getBrand(state, brandId),
    request: getRequest(state, 'deleteBrand')
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    deleteBrand,
    hideModal,
    resetRequest,
    showAlert,
    changePage
  }, dispatch);
}

const Confirmation = createClass({
  propTypes: {
    brandId: PropTypes.string.isRequired,
    brand: PropTypes.object.isRequired,
    request: PropTypes.object.isRequired,
    deleteBrand: PropTypes.func.isRequired,
    resetRequest: PropTypes.func.isRequired,
    showAlert: PropTypes.func.isRequired,
    changePage: PropTypes.func.isRequired
  },

  getInitialState() {
    return {password: ''};
  },

  onSuccess() {
    const {showAlert, hideModal, changePage} = this.props;

    hideModal();
    changePage('/brands');
    showAlert({
      type: 'success',
      message: i18n.get('ADV_BRAND_DELETE_CONFIRMATION_SUCCESS')
    });
  },

  onFail() {
    const {request, showAlert} = this.props;
    showAlert({
      type: 'error',
      time: 8000,
      message: request.response.message
    });
  },

  deleteBrand() {
    const {brandId, deleteBrand} = this.props;
    const {password} = this.state;

    deleteBrand({brandId, password})
      .then(this.onSuccess)
      .catch(this.onFail);
  },

  render() {
    const {brand = {}, hideModal, request, isOpen, onClose} = this.props;
    const {password} = this.state;
    const isLoading = request.status === 'loading';

    const content = (
      <div className='padding-1x'>
        <div className='flex width100 center-xs'>
          <BrandAvatar url={brand.image} name={brand.name} />
        </div>

        <h5 className='margin-top-2x vf-font-normal'>
          {i18n.getHTML('ADV_BRAND_DELETE_CONFIRMATION_BODY', {brandName: brand.name})}
        </h5>

        <div className='flex width100 end-xs margin-top-3x'>
          <Input
            type='password'
            value={password}
            placeholder={i18n.get('ADV_BRAND_DELETE_CONFIRMATION_PASSWORD_INPUT_PLACEHOLDER')}
            onChange={ev => this.setState({password: ev.target.value})}
          />

          <Button color='danger' disabled={!password || isLoading} onClick={this.deleteBrand}>
            {i18n.get('ADV_BRAND_DELETE_CONFIRMATION_DELETE_BUTTON')}
          </Button>
        </div>
      </div>
    );

    return (
      <Dialog
        isOpen={isOpen}
        size='sm'
        dismissable={false}
        header={i18n.get('ADV_BRAND_DELETE_CONFIRMATION_TITLE')}
        content={content}
        onClose={onClose || hideModal}
      />
    );
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(Confirmation);
